import '@/assets/css/attendanceCalendar.css';
import AttendanceCalendar from '../../components/Calendar';
import AttendanceSheetEstagiarioInfo from './components/AttendanceSheetEstagiarioInfo';
import AttendanceSheetHolidaysNotice from './components/AttendanceSheetHolidaysNotice';
import AttendanceSheetMonthSelector from './components/AttendanceSheetMonthSelector';
import AttendanceSheetResumeLittleTable from './components/AttendanceSheetResumeLittleTable';
import AttendanceSheetStatusActionsColumn from './components/AttendanceSheetStatusActionsColumn';
import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import ModalConfirmarAcao from '@/shared/components/modals/ModalProximaAcao';
import ModalHistorico from '../../modals/ModalHistoricoAttendanceSheet';
import MyContext from '@/shared/contexts/AppContext';
import { AttendanceSheetPdf } from '../../components/AttendanceSheetPDF';
import { AttendanceSheetResponseDto, ReadHolidayResponseDto, AttendanceSheetDayDto } from '@/api.types';
import { AttendanceSheetStatusEnum } from '../../../enums/attendance-sheet-status.enum';
import {
  CarregarPermissoes,
  ValidarPermissao,
} from '@/modules/system/auth/application/auth.service';
import { useNavigate, useParams } from 'react-router-dom';
import { PermissionEnum } from '@/modules/system/auth/domain/enums/permission.enum';
import { RoleEnum } from '@/modules/system/auth/domain/enums/role.enum';
import { diasDaSemana } from '@/shared/utils/datas';
import { exportFromJsxToPdf } from '@/shared/utils/pdf';
import { readByIdAttendanceSheet, sendToSignatureAttendanceSheet } from '../../../attendance-sheet.service';
import { readHoliday } from '@/modules/business/holidays/holiday.service';
import { toast, ToastContainer } from 'react-toastify';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { Modal } from 'react-bootstrap';
import { calcularCargaHorariaMaximaFromLotacao, obterUltimaJustificativaRejeicao } from './attendanceSheetEdit.utils';
import { NavigationView } from '@/shared/constants/navigation-view.enum';

export default function AttendanceSheetEditPage() {
  const context = useContext(MyContext);
  if (!context)
    throw new Error('Contexto deve ser usado dentro de um Provedor.');

  const { setActions } = useBreadcrumbActions();

  const params = useParams();
  const navigate = useNavigate();
  const folhaId = params.id;

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showModalHistorico, setShowModalHistorico] = useState(false);
  const [showModalJustificativa, setShowModalJustificativa] = useState(false);
  const [acaoDeConfirmar, setAcaoDeConfirmar] = useState(true);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [isExecuting, setExecuting] = useState<boolean>(false);

  const [textoBtnA, setTextoBotaoA] = useState<string | undefined>('');
  const [textoBtnB, setTextoBotaoB] = useState<string | undefined>('');
  const [tituloDaCaixaDeTexto, setTituloDaCaixaDeTexto] = useState<string>('');
  const [tituloBotaoPrincipal, settituloBotaoPrincipal] = useState<string>('');
  const [corpoDaCaixaDeTexto, setCorpoDaCaixaDeTexto] = useState<string>('');
  const [mesSelecionado, setMesSelecionado] = useState<string>('');

  const [folha, setFolha] = useState<AttendanceSheetResponseDto>();
  const [feriados, setFeriados] = useState<ReadHolidayResponseDto[]>([]);

  const { authVisao } = context;

  const permissoes = CarregarPermissoes();
  const podeAtualizarFolha =
    !!context.state.username &&
    ValidarPermissao(permissoes, [{ role: RoleEnum.FOLHA, level: PermissionEnum.UPDATE }]);
  const ehSubcorregedoria = authVisao === NavigationView.Subcorregedoria;
  const ehResponsavelPorVisao =
    authVisao === NavigationView.Defensor ||
    authVisao === NavigationView.DefensorDiretor ||
    authVisao === NavigationView.Colaborador;

  async function printAttendanceSheet(folhaId: string) {
    try {
      const folha = await readByIdAttendanceSheet(folhaId);
      exportFromJsxToPdf(<AttendanceSheetPdf folha={folha} />);
    } catch (error) {
      toast.error(String(error));
    }
  }

  useEffect(() => {
    setLoaded(false);

    async function fetchData() {
      try {
        if (!folhaId) {
          navigate(Links.Home, { replace: true });
          return;
        }

        const folhaResult = await readByIdAttendanceSheet(folhaId);

        if (!folhaResult) {
          navigate(Links.Home, { replace: true });
          return;
        }

        setFolha(folhaResult);

        const idDefensoria = folhaResult?.estagio?.lotacao?.defensoria?.id;
        const idSetor = (folhaResult as any)?.estagio?.lotacao?.setor?.id;
        // Datas em YYYY-MM-DD no mês da folha (evita problemas de timezone)
        const fromDate = `${folhaResult.ano}-${String(folhaResult.mes).padStart(2, '0')}-01`;
        const lastDayOfMonth = new Date(folhaResult.ano, folhaResult.mes, 0);
        const toDate = `${lastDayOfMonth.getFullYear()}-${String(lastDayOfMonth.getMonth() + 1).padStart(2, '0')}-${String(lastDayOfMonth.getDate()).padStart(2, '0')}`;

        const filters: { skip: number; take: number; fromDate: string; toDate: string; defensoriaId?: number; setorId?: number } = { skip: 0, take: 10000, fromDate, toDate, };

        if (idDefensoria != null && idDefensoria > 0)
          filters.defensoriaId = idDefensoria;

        else if (idSetor != null && idSetor > 0)
          filters.setorId = idSetor;

        const feriadosResult = await readHoliday(filters);

        const lista = Array.isArray(feriadosResult) && Array.isArray(feriadosResult[0]) ? feriadosResult[0] : [];
        const firstDayDate = new Date(fromDate);
        const lastDayDate = new Date(toDate);
        const feriadosDoMes = lista.filter((f) => {
          const inicio = new Date(f.inicio);
          const fim = f.fim ? new Date(f.fim) : inicio;
          return inicio <= lastDayDate && fim >= firstDayDate;
        });

        setFeriados(feriadosDoMes);
        setMesSelecionado(`${folhaResult.ano}-${String(folhaResult.mes).padStart(2, '0')}`);
      } catch (error) {
        toast.error(String(error));
      } finally {
        setLoaded(true);
      }
    }

    fetchData();
  }, [folhaId, navigate]);

  useEffect(() => {
    if (!folhaId) return;

    setActions({
      secondary: { label: 'Imprimir', onClick: () => printAttendanceSheet(folhaId) },
    });

    return () => setActions({});
  }, [folhaId, setActions]);

  useEffect(() => {
    setTextoBotaoA('');
    setTextoBotaoB('');
    if (folha) {
      switch (folha?.status) {
        case AttendanceSheetStatusEnum.CONCLUIDA:
          setTextoBotaoA('');
          setTextoBotaoB('');
          break;
        case AttendanceSheetStatusEnum.EM_PREENCHIMENTO:
        case AttendanceSheetStatusEnum.EM_CORRECAO:

          // Se é o estagiário
          if (context.state.cpf && folha.estagiario?.cpf && context.state.cpf === folha.estagiario.cpf) {
            setTextoBotaoA('Enviar para Assinatura');
          }
          // Se esta logado e é Subdefensoria Pública-Geral.
          else if (ehSubcorregedoria && podeAtualizarFolha) {
            setTextoBotaoA('Enviar para Assinatura.');
          }
          setTextoBotaoB('');

          break;
        case AttendanceSheetStatusEnum.AGUARDANDO_ASSINATURA:

          if (
            ehResponsavelPorVisao &&
            podeAtualizarFolha &&
            context.state.cpf &&
            folha.responsavel?.cpf &&
            context.state.cpf === folha.responsavel.cpf
          ) {
            setTextoBotaoA('Assinar e Enviar para a Subdefensoria');
            setTextoBotaoB('Pedir Correção');
          } else if (ehSubcorregedoria && podeAtualizarFolha) {
            setTextoBotaoA('Assinar e Enviar para a Subdefensoria.');
            setTextoBotaoB('Pedir Correção.');
          }
          break;
        case AttendanceSheetStatusEnum.AGUARDANDO_REVISAO:
          if (ehSubcorregedoria && podeAtualizarFolha) {
            setTextoBotaoA('Aceitar e Finalizar');
            setTextoBotaoB('Pedir Correção');
          }
          break;
      }
    }
  }, [folha, folha?.status, context.state.cpf, context.state.username, authVisao, ehSubcorregedoria, ehResponsavelPorVisao, podeAtualizarFolha]);

  useEffect(() => {
    if (folha) {
      switch (folha?.status) {
        case AttendanceSheetStatusEnum.CONCLUIDA:
          setTituloDaCaixaDeTexto('');
          setCorpoDaCaixaDeTexto('');
          settituloBotaoPrincipal('');
          break;
        case AttendanceSheetStatusEnum.EM_PREENCHIMENTO:
        case AttendanceSheetStatusEnum.EM_CORRECAO:
          setTituloDaCaixaDeTexto('Enviar para Assinatura');
          setCorpoDaCaixaDeTexto(
            'Deseja realmente enviar esta folha de frequência para assinatura?',
          );
          settituloBotaoPrincipal('Enviar para Assinatura');
          break;
        case AttendanceSheetStatusEnum.AGUARDANDO_ASSINATURA:
          setTituloDaCaixaDeTexto(
            acaoDeConfirmar
              ? 'Aprovar a folha do estagiário'
              : 'Rejeitar a folha do estagiário',
          );
          setCorpoDaCaixaDeTexto(
            acaoDeConfirmar
              ? 'Deseja aceitar e assinar esta folha de frequência?'
              : 'Deseja rejeitar esta folha de frequência?',
          );
          settituloBotaoPrincipal(acaoDeConfirmar ? 'Aprovar' : 'Rejeitar');
          break;
        case AttendanceSheetStatusEnum.AGUARDANDO_REVISAO:
          setTituloDaCaixaDeTexto(
            acaoDeConfirmar
              ? 'Aprovar a folha do estagiário'
              : 'Rejeitar a folha do estagiário',
          );
          setCorpoDaCaixaDeTexto(
            acaoDeConfirmar
              ? 'Deseja aceitar e devolver esta folha de frequência?'
              : 'Deseja rejeitar esta folha de frequência?',
          );
          settituloBotaoPrincipal(acaoDeConfirmar ? 'Aprovar' : 'Rejeitar');
          break;
      }
    }
  }, [folha, acaoDeConfirmar]);

  const updateCalendarDay = async (_modifiedDay: AttendanceSheetDayDto) => {
    if (!folha) return;
    try {
      const folhaAtualizada = await readByIdAttendanceSheet(folha.id);
      setFolha(folhaAtualizada);
    } catch (error) {
      toast.error(String(error));
    }
  };

  async function handleSendToSignature(motivo?: string) {
    if (!folha || !folhaId)
      return;

    setExecuting(true)
    await sendToSignatureAttendanceSheet(folhaId, acaoDeConfirmar, motivo)
      .then(async (res) => {
        toast.success(res);

        // Recarrega os dados da folha para manter os dias
        const folhaAtualizada = await readByIdAttendanceSheet(folhaId);
        setFolha(folhaAtualizada);
      })
      .catch((error) => {
        toast.error(String(error));
      })
      .finally(() => {
        setExecuting(false);
        setShowConfirmModal(false);
      });
  }

  const opcoesFolhasEstagiario = useMemo(() => folha?.folhasDisponiveisEstagiario ?? [], [folha?.folhasDisponiveisEstagiario]);

  if (!loaded)
    return <Loading />;

  return (
    <div className="container container-frequencia">
      <ToastContainer position="top-left" pauseOnFocusLoss={false} />

      <div className='row'>
        {folha && <AttendanceSheetEstagiarioInfo folha={folha} />}

        <div className="col-4">
          <div className="btn-group mb-4">
            <AttendanceSheetMonthSelector
              opcoes={opcoesFolhasEstagiario}
              folhaIdAtual={folhaId}
              mesSelecionado={mesSelecionado}
              anoFolha={folha?.ano}
              mesFolha={folha?.mes}
              onTrocarFolha={(id) => navigate(`${Links.Folha_Frequencia_Editar}/${id}`, { replace: true })}
            />
          </div>
        </div>
      </div>

      <div className="calendario">
        <div className="cabecalho-semana">
          {diasDaSemana.map((dia, index) => (
            <div key={index} className="dia-cabecalho">
              {dia}
            </div>
          ))}
        </div>
      </div>

      {folha && (
        <AttendanceCalendar
          folha={folha}
          updateCalendarDay={updateCalendarDay}
          horarioPadraoEntrada={folha.estagio.lotacao?.entrada ?? ''}
          horarioPadraoSaida={folha.estagio.lotacao?.saida ?? ''}
          isWeekendWorker={folha.estagio.fim_semana}
          cargaHorariaMaxima={calcularCargaHorariaMaximaFromLotacao(folha.estagio.lotacao)}
        />
      )}

      <div className="row mt-3">

        <div className='col-md-4'>
          <AttendanceSheetResumeLittleTable folha={folha} />
        </div>

        <div className='col-md-4'>
          <AttendanceSheetHolidaysNotice feriados={feriados} />
        </div>

        <AttendanceSheetStatusActionsColumn
          status={folha?.status}
          textoBtnA={textoBtnA}
          textoBtnB={textoBtnB}
          isExecuting={isExecuting}
          onAbrirModalPrimario={() => {
            setShowConfirmModal(true);
            setAcaoDeConfirmar(true);
          }}
          onAbrirModalSecundario={() => {
            setShowConfirmModal(true);
            setAcaoDeConfirmar(false);
          }}
          onAbrirJustificativaCorrecao={() => setShowModalJustificativa(true)}
        />
      </div>

      <footer className="text-center" style={{ position: 'fixed', bottom: 0, left: 0, width: '100%', background: '#f8f9fa', padding: '8px 0', borderTop: '1px solid #dee2e6', zIndex: 100, }} >
        <span style={{ fontSize: 16 }} onClick={() => { setShowModalHistorico(true) }}>
          Este acesso é pessoal e intransferível. Todas as ações são registradas
          com data, hora e IP.
        </span>
      </footer>

      <ModalConfirmarAcao
        show={showConfirmModal}
        executing={isExecuting}
        tituloBotaoPrincipal={tituloBotaoPrincipal}
        tituloDaCaixaDeTexto={tituloDaCaixaDeTexto}
        corpoDaCaixaDeTexto={corpoDaCaixaDeTexto}
        handleAcaoPrincipal={handleSendToSignature}
        handleHide={() => {
          setShowConfirmModal(false);
        }}
      />

      {folha &&
        <ModalHistorico
          folha={folha}
          show={showModalHistorico}
          handleHide={() => { setShowModalHistorico(false) }}
        />
      }

      <Modal show={showModalJustificativa} onHide={() => setShowModalJustificativa(false)} centered >
        <Modal.Header closeButton>
          <Modal.Title>Justificativa da correção</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">
            {folha ? obterUltimaJustificativaRejeicao(folha) : 'Não informado'}
          </p>
        </Modal.Body>
      </Modal>
    </div >
  );
}